import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize, deserializeErrors } from "utils/storeUtils";
import InviteRepository from "repositories/InviteRepository";

const initialState = {
  invite: null,
};

const invitesSlice = createSlice({
  name: "invite",
  initialState,
  reducers: {
    setInvite(state, { payload }) {
      state.invite = payload;
    },
  },
});

export const { actions } = invitesSlice;
export default invitesSlice.reducer;

export const useInviteActions = () => {
  const dispatch = useDispatch();

  const createInvite = (params) => {
    return InviteRepository.create(params)
      .then(({ data }) => {
        const invite = deserialize(data);
        dispatch(invitesSlice.actions.setInvite(invite));
        return invite;
      })
      .catch((error) => {
        return Promise.reject(deserializeErrors(error));
      });
  };

  const loadInvite = (slug) => {
    return InviteRepository.show(slug).then((response) => {
      const invite = deserialize(response.data);
      dispatch(invitesSlice.actions.setInvite(invite));
      return invite;
    });
  };

  const createGuest = (invite, params) => {
    return InviteRepository.addGuest(invite.id, params)
      .then((response) => {
        return deserialize(response.data);
      })
      .catch((error) => {
        return Promise.reject(deserializeErrors(error));
      });
  };

  return {
    createInvite,
    loadInvite,
    createGuest,
  };
};
